module.exports = __webpack_public_path__ + "static/media/circle-arrow-r.648b119b.svg";